import React from 'react';
import { SectionHeader, FadeIn } from '../ui';
export function Communication() {
  return <section className="py-16 md:py-24 bg-atrium-ink text-atrium-ivory relative overflow-hidden" data-id="element-99">
      {/* Subtle background motif */}
      <div className="absolute top-0 right-0 w-1/2 h-full border-l border-atrium-stone/10 opacity-20 pointer-events-none" data-id="element-100" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center" data-id="element-102">
          <div className="w-full lg:w-1/2" data-id="element-103">
            <FadeIn data-id="element-104">
              <SectionHeader eyebrow="No Surprises" title="Communication you can actually rely on" light data-id="element-105" />
              <div className="space-y-6 text-atrium-stone leading-relaxed" data-id="element-106">
                <p data-id="element-107">
                  A luxury build requires more than just exceptional
                  craftsmanship; it demands open lines of communication and a
                  dedicated team.
                </p>
                <p data-id="element-108">
                  From your first consultation to final handover, you stay well
                  informed through the whole build. Our transparent sales
                  process and direct director involvement ensure that your
                  vision is executed flawlessly, without the stress of the
                  unknown.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-109">
            <FadeIn delay={200} data-id="element-110">
              <div className="relative p-8 md:p-12 border border-atrium-stone/20 bg-white/[0.04]" data-id="element-111">
                <svg className="absolute top-6 left-6 w-8 h-8 text-atrium-bronze/40" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true" data-id="element-112">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.896 3.456-8.352 9.12-8.352 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" data-id="element-113" />
                </svg>
                <blockquote className="relative z-10 mt-4" data-id="element-114">
                  <p className="text-lg md:text-xl font-serif leading-relaxed text-atrium-ivory mb-6" data-id="element-115">
                    "We were recommended to see Atrium Homes to build our next
                    family home and it has been a remarkably satisfying journey,
                    ensured no nasty surprises at prestart."
                  </p>
                  <footer className="text-sm font-bold tracking-wider text-atrium-bronze uppercase" data-id="element-116">
                    — Hoff
                  </footer>
                </blockquote>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}